import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { FullscreenModalLock } from '../fullscreen-modal-lock'
import { PaywallLock } from '../paywall-lock'
import {
  JurisThreeOffersSwitchFrequencyLock_OfferLockDataFragment,
  JurisThreeOffersSwitchFrequencyLock_ViewerFragment,
} from './__generated__/juris-three-offers-switch-frequency-lock.graphql'
import { JurisThreeOffersSwitchFrequencyLockContent } from './juris-three-offers-switch-frequency-lock-content'

export interface JurisThreeOffersSwitchFrequencyLockProps {
  offerLockData: JurisThreeOffersSwitchFrequencyLock_OfferLockDataFragment
  viewer: JurisThreeOffersSwitchFrequencyLock_ViewerFragment
}

export function JurisThreeOffersSwitchFrequencyLock({
  offerLockData,
  viewer,
}: JurisThreeOffersSwitchFrequencyLockProps) {
  const { componentType } = useContext(BoxLockContext)
  const isPaywall = componentType === 'paywall'

  const content = (
    <JurisThreeOffersSwitchFrequencyLockContent
      viewer={viewer}
      offerLockData={offerLockData}
      isPaywall={isPaywall}
    />
  )

  switch (componentType) {
    case 'paywall':
      return <PaywallLock offerLockData={offerLockData}>{content}</PaywallLock>
    case 'modal':
      return <FullscreenModalLock offerLockBody={offerLockData.body}>{content}</FullscreenModalLock>
    default:
      return null
  }
}

JurisThreeOffersSwitchFrequencyLock.fragments = {
  offerLockData: gql`
    fragment JurisThreeOffersSwitchFrequencyLock_offerLockData on OfferLockData {
      ...JurisThreeOffersSwitchFrequencyLockContent_offerLockData
      ...PaywallLock_offerLockData
      body {
        ...FullscreenModalLock_offerLockBody
      }
    }
    ${FullscreenModalLock.fragments.offerLockBody}
    ${PaywallLock.fragments.offerLockData}
    ${JurisThreeOffersSwitchFrequencyLockContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment JurisThreeOffersSwitchFrequencyLock_viewer on Profile {
      ...JurisThreeOffersSwitchFrequencyLockContent_viewer
    }
    ${JurisThreeOffersSwitchFrequencyLockContent.fragments.viewer}
  `,
}
